import React from 'react';
import { CheckCircle, Clock, XCircle, AlertCircle, Archive, FileText } from 'lucide-react';

/**
 * Badge de estado para documentos
 * Estados: draft, pending, approved, rejected, expired, archived
 */
export default function DocumentStatusBadge({ estado, size = 'md' }) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  const iconSizes = {
    sm: 12,
    md: 14,
    lg: 16
  };

  const statusConfig = {
    draft: {
      label: 'Borrador',
      icon: FileText,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300'
    },
    pending: {
      label: 'Pendiente',
      icon: Clock,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-700',
      borderColor: 'border-yellow-300'
    },
    approved: {
      label: 'Aprobado',
      icon: CheckCircle,
      bgColor: 'bg-green-100',
      textColor: 'text-green-700',
      borderColor: 'border-green-300'
    },
    rejected: {
      label: 'Rechazado',
      icon: XCircle,
      bgColor: 'bg-red-100',
      textColor: 'text-red-700',
      borderColor: 'border-red-300'
    },
    expired: {
      label: 'Vencido',
      icon: AlertCircle,
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-700',
      borderColor: 'border-orange-300'
    },
    archived: {
      label: 'Archivado',
      icon: Archive,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-500',
      borderColor: 'border-gray-300'
    }
  };

  const config = statusConfig[estado] || statusConfig.draft;
  const Icon = config.icon;

  return (
    <span className={`
      inline-flex items-center gap-1.5 font-semibold rounded-full border
      ${sizeClasses[size]}
      ${config.bgColor}
      ${config.textColor}
      ${config.borderColor}
    `}>
      <Icon size={iconSizes[size]} />
      {config.label}
    </span>
  );
}
